import { ConfigProvider, Form, Input } from "antd";
import classes from "./ManagerForm.module.css";
import {
  ruleEmailVtorf,
  ruleFormatPhoneNumber,
  ruleRequired,
} from "../../../../constants/rules/RulesConstantsForms";
import {
  ruleLettersOnly,
  ruleNameMax,
  ruleNameMin,
  rulePatronymicMax,
  rulePatronymicMin,
  ruleSurnameMax,
  ruleSurnameMin,
} from "../../../../constants/rules/RulesConstantsUser";
import { PHONE_NUMBER_MASK_CONSTANT_WITH_WHITESPACE } from "../../../../constants/MaskConstants";
import MaskedInput from "antd-mask-input";
import { formPasswordValidator } from "../../../../utils/utilities/validatePassword";
import { IManagerFormDefaultValues } from "../../../../interfaces/AdminManagerInfo/IManagerFormDefaultValues";
import { IManagerFormProps } from "../../../../interfaces/props/AdminManagerInfo/IManagerFormProps";
import { PHONE_NUMBER_PATTERN } from "../../../../constants/regexp/PhoneNumberRegexp";
import { formatPhoneNumber } from "../../../../utils/utilities/formatPhoneNumber";

export const ManagerForm = ({
  onFinish,
  disabled,
  isEdit,
  formId,
  formInstance,
  defaultFormValues,
}: IManagerFormProps) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            itemMarginBottom: 0,
            colorTextLabel: "rgba(0, 0, 0, 0.5)",
          },
        },
      }}
    >
      <Form<IManagerFormDefaultValues>
        name={"RegisterUser"}
        id={formId}
        form={formInstance}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        className={classes.form}
        disabled={disabled}
      >
        <Form.Item
          required={false}
          label={<span className={classes.formLabel}>Фамилия</span>}
          name={"surname"}
          help={isEdit ? undefined : false}
          rules={[
            ruleRequired,
            ruleLettersOnly,
            ruleSurnameMax,
            ruleSurnameMin,
          ]}
        >
          {isEdit ? (
            <Input className={classes.input} />
          ) : (
            <div className={classes.fieldInfo}>
              {defaultFormValues?.surname}
            </div>
          )}
        </Form.Item>
        <Form.Item
          required={false}
          label={<span className={classes.formLabel}>Имя</span>}
          name={"name"}
          help={isEdit ? undefined : false}
          rules={[ruleRequired, ruleLettersOnly, ruleNameMax, ruleNameMin]}
        >
          {isEdit ? (
            <Input className={classes.input} />
          ) : (
            <div className={classes.fieldInfo}>{defaultFormValues?.name}</div>
          )}
        </Form.Item>
        <Form.Item
          required={false}
          label={<span className={classes.formLabel}>Отчество</span>}
          name={"patronymic"}
          rules={[ruleLettersOnly, rulePatronymicMax, rulePatronymicMin]}
          help={isEdit ? undefined : false}
        >
          {isEdit ? (
            <Input className={classes.input} />
          ) : (
            <div className={classes.fieldInfo}>
              {defaultFormValues?.patronymic}
            </div>
          )}
        </Form.Item>

        <Form.Item
          required={false}
          label={<span className={classes.formLabel}>Электронная почта</span>}
          rules={isEdit ? [ruleRequired, ruleEmailVtorf] : []}
          help={isEdit ? undefined : false}
          name={"email"}
        >
          {isEdit ? (
            <Input className={classes.input} />
          ) : (
            <div className={classes.fieldInfo}>{defaultFormValues?.email}</div>
          )}
        </Form.Item>
        <Form.Item
          required={false}
          label={<span className={classes.formLabel}>Телефон</span>}
          name={"phone_number"}
          help={isEdit ? undefined : false}
          rules={[ruleRequired, ruleFormatPhoneNumber]}
        >
          {isEdit ? (
            <MaskedInput
              color="default"
              variant="outlined"
              mask={PHONE_NUMBER_MASK_CONSTANT_WITH_WHITESPACE}
              onChange={(e) => {
                formInstance.setFieldValue(
                  "phone_number",
                  formatPhoneNumber(e.target.value),
                );
              }}
              className={classes.input}
              disabled={disabled}
            />
          ) : (
            <div className={classes.fieldInfo}>
              {defaultFormValues?.phone_number}
            </div>
          )}
        </Form.Item>
        <Form.Item
          required={false}
          label={<span className={classes.formLabel}>Пароль</span>}
          name={"password"}
          help={isEdit ? undefined : false}
          rules={[
            ruleRequired,
            {
              validator: formPasswordValidator,
            },
          ]}
        >
          {isEdit ? (
            <Input.Password className={classes.input} />
          ) : (
            <div className={classes.fieldInfo}>
              {defaultFormValues?.password}
            </div>
          )}
        </Form.Item>
      </Form>
    </ConfigProvider>
  );
};
